import find from "lodash/fp/find";
import constants from "../../core/constants";
import moment from "moment";

import addSubscriptionDialogCtrl from "./addSubscriptionDialog/addSubscriptionDialog.controller";
import addSubscriptionDialogTmpl from "./addSubscriptionDialog/addSubscriptionDialog.html";
import assignCaptainDialogCtrl from "./assignCaptainDialog/assignCaptainDialog.controller";
import assignCaptainDialogTmpl from "./assignCaptainDialog/assignCaptainDialog.html";
import rebookDialogCtrl from "./rebookDialog/rebookDialog.controller";
import rebookDialogTmpl from "./rebookDialog/rebookDialog.html";
import payDialogCtrl from "./payDialog/payDialog.controller";
import payDialogTmpl from "./payDialog/payDialog.html";
import invoiceItemDialogCtrl from "./invoiceItemDialog/invoiceItemDialog.controller";
import invoiceItemDialogTmpl from "./invoiceItemDialog/invoiceItemDialog.html";

class Controller {
  constructor(Events, Lists, $mdDialog, $injector, $state, Authentication) {
    "ngInject";

    this.Events = Events;
    this.Lists = Lists.all;
    this.$state = $state;
    this.$injector = $injector;
    this.$mdDialog = $mdDialog;
    this.Messages = $injector.get("Messages");
    this.userId = Authentication.getValue("owner");
    this.selectedItems = [];
    this.limitOptions = constants.tableLimitOptions;
    this.page = 1;
    this.limit = 10;
  }

  $onInit() {
    this.resourceParams = this.resourceParams || {};
    const showNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const errorEvent = this.Events.eventsType.onShowErrorNotification;
    this.fields = this.setSortFields(this.fields);
    const formatDateTime = (date) =>
      moment(date).format(constants.dateTimeFormat);
    const getConfirmDialog = (title, confirmClick, details) =>
      this.$mdDialog
        .confirm()
        .title(title)
        .textContent(details)
        .ok(confirmClick || "Ok")
        .cancel("Cancel");

    const get = (params = this.resourceParams) => {
      if (!params) params = {};
      params.page = params.page ? params.page : this.page;
      params.limit = params.limit ? params.limit : this.limit;

      const resource = this.$injector.get(this.resource);
      const request = resource[this.resourceMethod || "getAll"].bind(resource);

      const requestPromise = request(params, this.resourceName, this.resourceId)
        .$promise;
      requestPromise.then((response) => {
        const justifierModule = this.$injector.get(this.resourceTransformer);
        if (this.resourceTransformer === "BookingsTransforms") {
          this.items = this.resourceTransformerMethod
            ? justifierModule[this.resourceTransformerMethod](
                response.hits || response.transactions
              )
            : justifierModule.justify(
                response.hits || response.transactions || response.data,
                this.resourceParams.ride
              );
        } else {
          this.items = this.resourceTransformerMethod
            ? justifierModule[this.resourceTransformerMethod](
                response.hits || response.transactions
              )
            : justifierModule.justify(
                response.hits || response.transactions || response.data
              );
        }

        this.total = response.total;
      });
    };

    if (this.actionSuccessResponseEvent) {
      this.Events.on(this.actionSuccessResponseEvent, get);
    }
    const markAsCancelled = (action, item) => {
      const date = formatDateTime(new Date(item.date));
      const markAsCancelledConfirm = getConfirmDialog(
        `Are you sure you want to mark this ride "${date}" as cancelled ?`
      );
      this.$mdDialog.show(markAsCancelledConfirm).then(
        () => {
          this.$injector
            .get(action.resource)
            .cancel(item._id)
            .$promise.then(
              () => {
                this.Events.emit(
                  showNotificationEvent,
                  this.Messages.cancelRide()
                );
                get();
              },
              (response) => this.Events.emit(errorEvent, response.data)
            );
        },
        () => {}
      );
    };

    const assignCaptain = (action, item) => {
      const rideName = item.route.name + "  " + formatDateTime(item.date);
      const assign = this.$mdDialog.show({
        controller: assignCaptainDialogCtrl,
        controllerAs: "$ctrl",
        template: assignCaptainDialogTmpl,
        locals: { rideName },
      });

      assign.then(
        (obj) => {
          this.$injector
            .get(action.resource)
            .update(item._id, { captain: obj._id })
            .$promise.then(
              () => {
                this.Events.emit(
                  showNotificationEvent,
                  this.Messages.assignCaptainMessage()
                );
                get();
              },
              (response) => this.Events.emit(errorEvent, response.data)
            );
        },
        () => {}
      );
    };

    const checkInBooking = (action, item) => {
      const checkInBookingConfirm = getConfirmDialog(
        "Are you sure you want to check in this booking?",
        "check in",
        `Customer: ${item.user.name}, Ride: ${
          item.ride.route.name
        }, Date: ${formatDateTime(item.ride.date)}`
      );

      this.$mdDialog.show(checkInBookingConfirm).then(
        () => {
          this.$injector
            .get(action.resource)
            .checkIn(item._id)
            .$promise.then(
              () => {
                this.Events.emit(
                  showNotificationEvent,
                  this.Messages.checkInMessage()
                );
                get();
              },
              (response) => this.Events.emit(errorEvent, response.data)
            );
        },
        () => {}
      );
    };

    const cancelRefund = (action, item, isRefund) => {
      const message = isRefund ? "refund" : "cancel and refund";
      const customer = item.user.name;
      const ride =
        item.ride.route.name +
        " " +
        moment(item.ride.date).format(constants.dateTimeFormat);
      const pickup = item.pick_up.name;
      const dropoff = item.drop_off.name;
      const cancelRefund = getConfirmDialog(
        `Are you sure you want to ${message} "${customer}" booking?`,
        "OK",
        `Ride: ${ride}, Pickup: ${pickup}, Dropoff: ${dropoff}`
      );
      this.$mdDialog.show(cancelRefund).then(
        () => {
          const model = { refund_percentage: constants.refundPercentage };
          this.$injector
            .get(action.resource)
            .cancel(item._id, model)
            .$promise.then(
              () => {
                this.Events.emit(
                  showNotificationEvent,
                  this.Messages.cancelRefundMessage()
                );
                get();
              },
              (response) => this.Events.emit(errorEvent, response.data)
            );
        },
        () => {}
      );
    };
    const refund = (action, item) => cancelRefund(action, item, true);
    const rebook = (action, item) => {
      const rebook = this.$mdDialog.show({
        controller: rebookDialogCtrl,
        controllerAs: "$ctrl",
        template: rebookDialogTmpl,
        locals: { booking: item },
      });

      rebook.then(
        (changed) => {
          this.$injector
            .get(action.resource)
            .post(changed)
            .$promise.then(
              () => {
                this.Events.emit(
                  showNotificationEvent,
                  this.Messages.bookMessage()
                );
                get();
              },
              (response) => this.Events.emit(errorEvent, response.data)
            );
        },
        () => {}
      );
    };
    const removeSeat = (action, item) => {
      const removeSeatConfirm = getConfirmDialog(
        "Are you sure you want to remove this seat?"
      );
      this.$mdDialog.show(removeSeatConfirm).then(() => {
        this.$injector
          .get(action.resource)
          .delete(item._id.value)
          .$promise.then(
            () => {
              this.Events.emit(
                showNotificationEvent,
                this.Messages.removeMessage("seat")
              );
              get();
            },
            (response) => this.Events.emit(errorEvent, response.data)
          );
      });
    };

    const assignSeat = (action, item) => {
      const schedule = item.schedule._id;
      const routeId = item.route._id;
      const addSubs = this.$mdDialog.show({
        controller: addSubscriptionDialogCtrl,
        controllerAs: "$ctrl",
        template: addSubscriptionDialogTmpl,
        locals: { schedule, routeId },
      });

      addSubs.then(
        (obj) => {
          obj.corporate_reservation = item.corporate_reservation;
          this.$injector
            .get(action.resource)
            .assign(item._id.value, obj)
            .$promise.then(
              () => {
                this.Events.emit(
                  showNotificationEvent,
                  this.Messages.addMessage("subscription")
                );
                get();
              },
              (response) => this.Events.emit(errorEvent, response.data)
            );
        },
        () => {}
      );
    };

    const unassignSeat = (action, item) => {
      const removeSeatConfirm = getConfirmDialog(
        "Are you sure you want to unassign this seat?"
      );
      this.$mdDialog.show(removeSeatConfirm).then(() => {
        this.$injector
          .get(action.resource)
          .unassign(item._id.value)
          .$promise.then(
            () => {
              this.Events.emit(showNotificationEvent, {
                message: "Seat unassigned successfully",
              });
              get();
            },
            (response) => this.Events.emit(errorEvent, response.data)
          );
      });
    };

    const checkOutBooking = (action, item) => {
      const checkOutBookingConfirm = getConfirmDialog(
        "Are you sure you want to check out this booking?",
        "check out",
        `Customer: ${item.user.name}, Ride: ${
          item.ride.route.name
        }, Date: ${formatDateTime(item.ride.date)}`
      );

      this.$mdDialog.show(checkOutBookingConfirm).then(
        () => {
          this.$injector
            .get(action.resource)
            .checkOut(item._id)
            .$promise.then(
              () => {
                this.Events.emit(
                  showNotificationEvent,
                  this.Messages.checkOutMessage()
                );
                get();
              },
              (response) => this.Events.emit(errorEvent, response.data)
            );
        },
        () => {}
      );
    };
    const pay = (action, item) => {
      const pay = this.$mdDialog.show({
        controller: payDialogCtrl,
        controllerAs: "$ctrl",
        template: payDialogTmpl,
        locals: { booking: item },
      });

      pay.then(
        (amount) => {
          this.$injector
            .get(action.resource)
            .pay(item._id, amount)
            .$promise.then(
              () => {
                this.Events.emit(
                  showNotificationEvent,
                  this.Messages.payMessage()
                );
                get();
              },
              (response) => this.Events.emit(errorEvent, response.data)
            );
        },
        () => {}
      );
    };
    const createInvoice = (action, item) => {
      const confirmInvoice = getConfirmDialog(
        `Are you sure you want to create invoice for captain "${item.captain.name}"?`,
        "OK"
      );
      this.$mdDialog.show(confirmInvoice).then(() => {
        const data = { captain: item.captain._id };

        this.$injector
          .get(action.resource)
          .post(data)
          .$promise.then(
            () => {
              get();
              this.Events.emit(
                showNotificationEvent,
                this.Messages.invoiceCreated()
              );
            },
            (response) => this.Events.emit(errorEvent, response.data)
          );
      });
    };
    const getInvoiceDialogOptions = (locals) => {
      return {
        controller: invoiceItemDialogCtrl,
        controllerAs: "$ctrl",
        template: invoiceItemDialogTmpl,
        locals,
      };
    };
    const handleInvoiceItemActive = (action, item) => {
      const isActive = item.active;
      const message = isActive ? "deactivate" : "activate";
      const method = isActive ? "deactivate" : "activate";

      const confirm = this.$mdDialog.show(getInvoiceDialogOptions({ message }));
      confirm.then((obj) => {
        const resource = this.$injector.get(action.resource);
        const resourceMethod = resource[method].bind(resource);

        resourceMethod(item._id, obj).$promise.then(
          () => {
            get();
            this.Events.emit(showNotificationEvent, {
              message: `Invoice item ${message} successfully`,
            });
          },
          (response) => this.Events.emit(errorEvent, response.data)
        );
      });
    };

    const handleAddNote = (action, item) => {
      const confirm = this.$mdDialog.show(getInvoiceDialogOptions({}));

      confirm.then((obj) => {
        this.$injector
          .get(action.resource)
          .addNote(item._id, obj)
          .$promise.then(
            () => {
              this.Events.emit(showNotificationEvent, {
                message: "Your note added successfully",
              });
            },
            (response) => this.Events.emit(errorEvent, response.data)
          );
      });
    };

    const deactivateInvoiceItem = (action, item) =>
      handleInvoiceItemActive(action, item);
    const activateInvoiceItem = (action, item) =>
      handleInvoiceItemActive(action, item);
    const addInvoiceItemNote = (action, item) => handleAddNote(action, item);

    const deactivateCorporateInvoiceItem = (action, item) =>
      handleInvoiceItemActive(action, item);
    const activateCorporateInvoiceItem = (action, item) =>
      handleInvoiceItemActive(action, item);
    const addCorporateInvoiceItemNote = (action, item) =>
      handleAddNote(action, item);

    const goToInvoices = (_, item) => {
      this.$state.transitionTo("captaininvoices", { id: item.captain._id });
    };

    const createRideInvoiceItem = (action, item) => {
      const type = "ride";
      this.$injector
        .get(action.resource)
        .post({ ride: item._id, type })
        .$promise.then(
          () => {
            this.Events.emit(showNotificationEvent, {
              message: "Invoice Item created successfully",
            });
            get();
          },
          (response) => this.Events.emit(errorEvent, response.data)
        );
    };
    const refundTransaction = (action, item) => {
      const transactionId = item.id;
      const confirmInvoice = getConfirmDialog(
        "Are you sure you want to refund this transaction to user credit card?",
        "OK",
        "THIS ACTION CAN NOT BE UNDONE"
      );

      this.$mdDialog.show(confirmInvoice).then(() => {
        this.$injector
          .get(action.resource)
          .refund({ transaction_id: transactionId })
          .$promise.then(
            () => {
              this.Events.emit(showNotificationEvent, {
                message: "Invoice Item created successfully",
              });
            },
            (response) => this.Events.emit(errorEvent, response.data)
          );
      });
    };

    const removeUserPromotion = (action, item) => {
      const removeUserPromotionConfirm = getConfirmDialog(
        "Are you sure you want to remove this user from the promotion ?"
      );
      this.$mdDialog.show(removeUserPromotionConfirm).then(() => {
        this.$injector
          .get(action.resource)
          .delete(item._id)
          .$promise.then(
            () => {
              this.Events.emit(
                showNotificationEvent,
                this.Messages.removeMessage("user promotions")
              );
              get();
            },
            (response) => this.Events.emit(errorEvent, response.data)
          );
      });
    };

    const actions = {
      markAsCancelled,
      assignCaptain,
      checkInBooking,
      cancelRefund,
      refund,
      rebook,
      removeSeat,
      checkOutBooking,
      pay,
      createInvoice,
      goToInvoices,
      deactivateInvoiceItem,
      activateInvoiceItem,
      addInvoiceItemNote,
      createRideInvoiceItem,
      deactivateCorporateInvoiceItem,
      activateCorporateInvoiceItem,
      addCorporateInvoiceItemNote,
      assignSeat,
      unassignSeat,
      refundTransaction,
      removeUserPromotion,
    };

    get(this.resourceParams);

    this.onPaginate = (page, limit) => {
      if (page) this.resourceParams.page = page;
      if (limit) this.resourceParams.limit = limit;

      get(this.resourceParams);
    };

    this.onSort = (field) => {
      if (field.isSortable) {
        this.selectedSort = this.toggleSortField(field).sortBy;
        this.fields = this.setSortFields(this.fields);

        this.resourceParams.sort = this.selectedSort;
        get(this.resourceParams);
      }
    };

    this.onSelectFilter = (field, selected) => {
      field.selected = selected;
      this.resourceParams[field.name] = selected;
      get(this.resourceParams);
    };

    this.openMenu = ($mdMenu, ev) => {
      $mdMenu.open(ev);
    };

    this.takeAction = (action, item) => {
      const actionMethod = actions[action.name];

      actionMethod(action, item);
    };

    this.hasFilter = (name) =>
      this.filters &&
      find((item) => item.name === name && item.list)(this.filters);
  }

  setSortFields(fields) {
    fields.forEach((field) => {
      const isSelectedRegex = new RegExp(`${field.name}$`, "g");
      const isDesc = constants.descSortRegex;
      if (field.isSortable) {
        if (
          isSelectedRegex.test(this.selectedSort) &&
          isDesc.test(this.selectedSort)
        ) {
          field.sortBy = `-${field.name}`;
          field.sortIcon = "arrow_upward";
          field.sortTooltip = "DECS";
        } else {
          field.sortBy = field.name;
          field.sortIcon = "arrow_downward";
          field.sortTooltip = "ASC";
        }
      }
    });

    return fields;
  }

  toggleSortField(field) {
    if (field.sortBy === field.name) {
      field.sortBy = `-${field.name}`;
      field.sortIcon = "arrow_upward";
      field.sortTooltip = "DESC";
    } else {
      field.sortBy = field.name;
      field.sortIcon = "arrow_downward";
      field.sortTooltip = "ASC";
    }

    return field;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/actionListTable/actionListTable.controller.js